import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Phone, Mail, MapPin } from 'lucide-react';

const SITE_LOGO = "https://customer-assets.emergentagent.com/job_9dd50a71-7bb8-45b9-bdec-566056107363/artifacts/kgdjrixe_Untitled%20design.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={SITE_LOGO} 
                alt="What's Happening Baltimore" 
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-zinc-400 text-base leading-relaxed max-w-md mb-6">
              Your source to stay in the pulse of Baltimore's Music and Arts. 
              Whether you're looking for things to do this weekend, this month, 
              or next year — we don't want you to miss a thing.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/sanity.lounge" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:text-white hover:bg-purple-600 transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
              <a 
                href="https://www.instagram.com/sanity.lounge/" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:text-white hover:bg-purple-600 transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a 
                href="https://www.youtube.com/@SanityLounge" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-youtube"
                className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:text-white hover:bg-purple-600 transition-all duration-300"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-outfit text-lg font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-zinc-400 hover:text-purple-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-zinc-400 hover:text-purple-500 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a 
                  href="https://events.whatshappeningbaltimore.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-zinc-400 hover:text-purple-500 transition-colors"
                >
                  Events
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-purple-500 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <a 
                  href="https://events.sanitylounge.com/selection" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-zinc-400 hover:text-purple-500 transition-colors"
                >
                  Submit Event
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-outfit text-lg font-semibold text-white mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-purple-500 mt-0.5 flex-shrink-0" />
                <a href="tel:+14109293182" className="text-zinc-400 hover:text-white transition-colors">
                  +410-929-3182
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-purple-500 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@sanitylounge.com" className="text-zinc-400 hover:text-white transition-colors">
                  info@sanitylounge.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-purple-500 mt-0.5 flex-shrink-0" />
                <span className="text-zinc-400">Baltimore, Maryland</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm">
            © {currentYear} What's Happening Baltimore. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="text-zinc-600 hover:text-purple-500 text-sm transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-zinc-600 hover:text-purple-500 text-sm transition-colors"
            >
              Terms of Use
            </Link>
            <Link
              to="/admin/login"
              className="text-zinc-600 hover:text-purple-500 text-sm transition-colors"
            >
              Admin
            </Link>
            <p className="text-zinc-600 text-sm">
              Supporting Baltimore Arts & Culture
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
